import VueRoute from 'vue-router'
import Vue from 'vue'
import Layout from '@/views/client-company/index/index.vue'
Vue.use(VueRoute)

const publicRoutes = [
    {
        path: '/',
        name: 'newIndex',
        component: () => import('@/views/index/indexv2.vue'),
        meta: {
            title: '首页',
        },
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('@/views/index/index.vue'),
        meta: {
            title: '首页',
        },
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login/index.vue'),
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/register/index.vue'),
    },
    {
        path: '/change-password',
        name: 'changePassword',
        component: () => import('../views/change-password/index.vue'),
        meta: {
            title: '修改密码',
        },
    },


    {
        path: '/notFound',
        name: 'notFound',
        component: () => import('../views/404.vue'),
    },
    {
        path: '/activity',
        name: 'activity',
        component: () => import('../views/activity/index.vue'),
    },
    {
        path: '/activity-detail',
        name: 'activityDetail',
        component: () => import('../views/activity/detail.vue'),
    },
    {
        path: '/talentReport',
        name: 'talentReport',
        component: () => import('../views/talentReport/indexDF.vue'),
    }
]
const companyRoutes = [
    {
        path: '/', // B端首页
        component: Layout,
        redirect: { name: 'companyAgent' },
        children: [
            {
                path: '/companyHome',
                name: 'companyHome',
                component: () => import('@/views/client-company/home/index.vue'),
                meta: {
                    title: '',
                },
            },
        ],
    },
    // 创建职位
    {
        path: '/createPosition',
        name: 'createPosition',
        component: () => import('../views/client-company/createPosition/index.vue'),
    },
    // 创建职位
    {
        path: '/blueCollar',
        name: 'blueCollar',
        component: () => import('../views/client-company/blueCollar/index.vue'),
    },
    // 面试报告
    {
        path: '/interviewReport',
        name: 'interviewReport',
        component: () => import('../views/client-company/interviewReport/index.vue'),
    },
    {
        path: '/interviewRecord', // 面试记录v
        component: Layout,
        redirect: { name: 'interviewRecord' },
        children: [
            {
                path: '/interviewRecord',
                name: 'interviewRecord',
                component: () => import('@/views/client-company/interviewRecord/index.vue'),
                meta: {
                    title: '面试记录',
                },
            },
        ],
    },
    {
        path: '/rights', // 权益页面
        component: Layout,
        redirect: { name: 'rights' },
        children: [
            {
                path: '/rights',
                name: 'rights',
                component: () => import('@/views/client-company/rights/index.vue'),
                meta: {
                    title: '权益',
                },
            },
        ],
    },
    {
        path: '/order', // 订单
        component: Layout,
        redirect: { name: 'order' },
        children: [
            {
                path: '/order',
                name: 'order',
                component: () => import('@/views/client-company/order/index.vue'),
                meta: {
                    title: '订单列表',
                },
            },
        ],
    },
    {
        path: '/RecordsOfConsumption', // 权益消费记录
        component: Layout,
        redirect: { name: 'RecordsOfConsumption' },
        children: [
            {
                path: '/RecordsOfConsumption',
                name: 'RecordsOfConsumption',
                component: () => import('@/views/client-company/RecordsOfConsumption/index.vue'),
                meta: {
                    title: '权益消费记录',
                },
            },
        ],
    },
    {
        path: '/inviteScanCode', // 邀请和扫码记录
        component: Layout,
        redirect: { name: 'inviteScanCode' },
        children: [
            {
                path: '/inviteScanCode',
                name: 'inviteScanCode',
                component: () => import('@/views/client-company/inviteScanCode/index.vue'),
                meta: {
                    title: '权益消费记录',
                },
            },
        ],
    }
]

const talentRoutes = [
    {
        path: '/talentHome',
        name: 'talentHome',
        component: () => import('../views/client-talent/home/index.vue'),
    },
    {
        path: '/Interview',
        name: 'Interview',
        component: () => import('../views/agentInterview/aiInterview.vue'),
    },
    {
        path: '/Assistant',
        name: 'Assistant',
        component: () => import('../views/Assistant/aiInterview.vue'),
    },
    {
        path: '/myResume',
        name: 'myResume',
        // component: () => import('../views/client-talent/myResume/index.vue'),
        component: () => import('../views/client-talent/onlineResume/index.vue'),
    },
    {
        path: '/myInterview',
        name: 'myInterview',
        component: () => import('../views/client-talent/myInterview/index.vue'),
    },
    {
        path: '/jobDetails',
        name: 'jobDetails',
        component: () => import('../views/client-talent/jobDetails/index.vue'),
    },
    {
        path: '/governmentAgent',
        name: 'governmentAgent',
        component: () => import('../views/governmentAgent/index.vue')
    },
    {
        path: '/userRights',
        name: 'userRights',
        component: () => import('../views/client-talent/userRights/index.vue'),
    },
    {
        path: '/userOrder',
        name: 'userOrder',
        component: () => import('../views/client-talent/userOrder/index.vue'),
    },
    {
        path: '/userConsumptionRecord',
        name: 'userConsumptionRecord',
        component: () => import('../views/client-talent/userConsumptionRecord/index.vue'),
    },
    {
        path: '/career-counseling',
        name: 'careerCounseling',
        component: () => import('@/views/client-talent/career-counseling/index.vue'),
        // redirect: { name: 'index'}, // 这块开发时隐藏
        meta: {
            title: '职业辅导'
        },
        children: [
            {
                path: 'mock-interview',
                name: 'mockInterview',
                component: () => import('@/views/client-talent/career-counseling/MockInterview.vue'),
                meta: {
                    title: '模拟面试'
                },
            },
            {
                path: 'mock-ai-interview',
                name: 'mockAIinterview',
                component: () => import('@/views/client-talent/career-counseling/AIinterview.vue'),
                meta: {
                    title: '模拟AI面试'
                },
            },
            {
                path: 'resume-optimization',
                name: 'resumeOptimization',
                component: () => import('@/views/client-talent/career-counseling/ResumeOptimization.vue'),
                meta: {
                    title: '简历优化'
                },
            },
            {
                path: 'counseling-record',
                name: 'counselingRecord',
                component: () => import('@/views/client-talent/career-counseling/InterviewRecord.vue'),
                meta: {
                    title: '面试记录'
                },
            },
            {
                path: 'ai-chat/:id?',
                name: 'aiChat',
                props: true,
                component: () => import('@/views/client-talent/career-counseling/AIChat.vue'),
                meta: {
                    title: '智能对话'
                },
            },
            {
                path: 'simulated-point-purchase',
                name: 'simulatedPointPurchase',
                component: () => import('@/views/client-talent/career-counseling/SimulatedPointPurchase.vue'),
                meta: {
                    title: '模拟点数购买'
                },
            },
            {
                path: 'my-order',
                name: 'myOrder',
                component: () => import('@/views/client-talent/career-counseling/MyOrder.vue'),
                meta: {
                    title: '我的订单'
                },
            },
            {
                path: 'equity-consumption',
                name: 'equityConsumption',
                component: () => import('@/views/client-talent/career-counseling/EquityConsumption.vue'),
                meta: {
                    title: '权益消费记录'
                },
            },
            {
                path: 'mock-interview-report',
                name: 'mockInterviewReport',
                component: () => import('@/views/talentReport/indexMockInterViewDF.vue'),
                meta: {
                    title: '模拟面试报告'
                },
            },
        ]
    },

    // {
    //     path: '/talentReports',
    //     name: 'talentReports',
    //     component: () => import('../views/talentReports/index.vue'),
    // },
]
const router = new VueRoute({
    // mode: 'hash',
    mode: 'history',
    routes: [...talentRoutes, ...publicRoutes, ...companyRoutes],
    scrollBehavior: () => ({ y: 0 }), // 滚动到哪个的位置
})

// // 添加全局前置守卫自动携带code参数
// router.beforeEach((to, from, next) => {
//   // 从当前路由或来源路由获取code参数
//   const code = to.query.code || from.query.code;
//   // 如果存在code且目标路由未携带，则自动添加
//   if (code && !to.query.code) {
//     // 避免直接修改to对象，创建新的query对象
//     const newQuery = { ...to.query, code };
//     next({ ...to, query: newQuery });
//   } else {
//     next();
//   }
// });
function getRouteNames(routes) {
    return routes.flatMap((route) => [route.name || '', ...(route.children?.map((child) => child.name) || [])]).filter(Boolean)
}
// 添加路由
const talentPaths = getRouteNames(talentRoutes)
const publicPaths = getRouteNames(publicRoutes)
const companyPaths = getRouteNames(companyRoutes)

// router.beforeEach(async (to, from, next) => {
//     const isLoggedIn = localStorage.getItem('token')
//     // 未登录
//     if (!isLoggedIn) {
//         if (publicPaths.includes(to.name)) {
//             next() // 放行公开路由
//         } else {
//             // 未登录跳转到业务路由，跳转登录页
//             next({ name: 'login' })
//         }
//         return
//     }
//     // 已登录
//     const client = localStorage.getItem('client') // user  company
//     // 旧版兼容 client tag 不同 stroage key
//     if (!client) {
//         localStorage.clear()
//     }
//     const authRoutes = [...publicPaths].concat(client === 'talent' ? talentPaths : companyPaths)
//     if (authRoutes.includes(to.name)) {
//         next()
//     } else {
//         next({ name: 'notFound', replace: true })
//     }
// })
router.beforeEach((to, from, next) => {

    // 获取邀请码（优先使用当前路由参数，否则使用来源路由参数）
    const newSalesCode = to.query.ic
    const prevSalesCode = from.query.ic
    const inviteActivityCode = to.query.invite_code
    // 从本地存储获取已保存的邀请码作为备选
    const storedSalesCode = localStorage.getItem('ic')
    const query = { ...to.query }

    // 持久化邀请码逻辑 - 确定当前有效的邀请码
    let currentSalesCode = newSalesCode || prevSalesCode || storedSalesCode
    if (currentSalesCode) {
        // 保存邀请码到本地存储，确保刷新页面后仍能保留
        localStorage.setItem('ic', currentSalesCode)
        // 如果当前查询参数中没有邀请码，则添加
        if (!query.ic) {
            query.ic = currentSalesCode
        }
    } else {
        // 如果没有任何邀请码，清除本地存储
        localStorage.removeItem('ic')
    }

    // 1. 先处理code参数持久化
    let code = to.query.code || localStorage.getItem('code')
    // const showFailTip = to.query.showFailTip || from.query.showFailTip
    // const rejectRecall = to.query.rejectRecall || from.query.rejectRecall
    if (to.query.code) {
        localStorage.setItem('code', to.query.code)
    }
    if (from.name === 'Interview') {
        if (query.code) {
            delete query.code
        }
        code = ''
    }
    if (code) {
        if (!to.query.code) {
            console.log('添加code参数', from)
            // 仅在目标路由无code时添加参数
            return next({ ...to, query: { ...query, code } })
        }
    } else {
        localStorage.removeItem('code')
    }

    const c = to.query.c
    const t = to.query.t
    const target = to.query.target
    if (c && t) {
        localStorage.setItem('token', t)
        localStorage.setItem('client', c)
        let routeName
        if (target) {
            routeName = target
        } else {
            routeName = c === 'talent' ? 'talentHome' : 'companyHome'
        }
        return next({ name: routeName, query: currentSalesCode ? { ic: currentSalesCode } : {} })
    }

    // 2. 再处理权限验证
    const isLoggedIn = localStorage.getItem('token')

    if (!isLoggedIn) {
        if (publicPaths.includes(to.name)) {
            // 如果是公开路径且需要添加邀请码
            if (currentSalesCode && !to.query.ic) {
                return next({ ...to, query })
            }
            return next()
        } else {
            const query = {
                ...to.query,
            }
            if (currentSalesCode) {
                query.ic = currentSalesCode
                delete query.invite_code
            }
            if (inviteActivityCode) {
                query.invite_code = inviteActivityCode
                delete query.ic
                localStorage.clear()
            }
            return next({ name: 'newIndex', query })
        }
    }
    const client = localStorage.getItem('client')

    // 3. 已登录用户权限检查
    const authRoutes = [...publicPaths].concat(client === 'talent' ? talentPaths : companyPaths)
    if (authRoutes.includes(to.name)) {
        // 如果有权限访问且需要添加邀请码
        if (currentSalesCode && !to.query.ic) {
            return next({ ...to, query })
        }
        next()
    } else {
        // 跳转到404页面时携带邀请码
        next({
            name: 'notFound',
            replace: true,
            query: currentSalesCode ? { ic: currentSalesCode } : {}
        })
    }
})
export default router
